import EntityBase from '@/data/EntityBase';
import type Absence from '@/data/absence/model';

export default class AbsenceState extends EntityBase<Absence, { absenceToView: string }>({
  absenceToView: '',
}) {}
